import CautionPhraseList from '../cautionPhraseList';

export default function CautionPhraseListPage() {
  return (
    <CautionPhraseList />
  );
}
